module.exports = __webpack_public_path__ + "media/images/courseDefault-0b28ebe16749791d1006a312ac95df03.png";